export const BUILD_INFO = {
  buildNumber: '05112026185436+0530D',
  environment: 'DEV'
};